module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    staticStyle: {
      "background-color": "#e8ebed"
    }
  }, [_c('section', {
    staticClass: "thick",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "hospital-logo-line"
  }, [_c('span', {
    staticClass: "logo-img"
  }), _vm._v(" "), _c('span', {
    staticClass: "logo-title",
    attrs: {
      "id": "register-hospital-title"
    }
  }, [_vm._v(_vm._s(_vm.hospitalName))])])]), _vm._v(" "), _c('div', {
    staticClass: "hos-info-name"
  }), _vm._v(" "), _c('div', {
    staticClass: "hospital-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.hospitalContent)
    }
  })]), _vm._v(" "), _c('footer', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.divShow),
      expression: "divShow"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('input', {
    staticClass: "chat-button-location-radio-input",
    attrs: {
      "id": "color-input-red",
      "type": "checkbox",
      "name": "color-input-red",
      "value": "#f0544d"
    },
    on: {
      "click": _vm.theSelected
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "color-input-red"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hos-hint"
  }, [_vm._v("阅读并同意《预约须知》")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "5px"
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn-ok",
    staticStyle: {
      "width": "96%",
      "margin-left": "2%"
    },
    attrs: {
      "id": "btn-submit",
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.confirmRegister
    }
  }, [_vm._v("\n          " + _vm._s(_vm.content) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d01fe16e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/registeredPrompt/registeredPrompt.vue
// module id = 875
// module chunks = 0